window.$ = window.jQuery = require('jquery');

// Base forms
$("#form").submit(function(e) {
    e.preventDefault();

    const form = $(this);
    const url = form.attr('action');
    let thankyoupage = form.attr('data-thanks');
    $(this).find('.button').addClass('button--loading').prop('disabled', true);

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function(data)
        {
            if(data === 'ok') {
                // Inline video demo form // try free step 2
                if($('#email').length > 0) {
                    thankyoupage = thankyoupage + '?email=' + $('#email').val();
                }
                window.location.href = thankyoupage;
            } else {
                alert('Het formulier kon niet verzonden worden. Probeer het nogmaals of neem contact met ons op.');
                $(this).find('.button').removeClass('button--loading').prop('disabled', false);
            }
        }
    });
});
